////////////////////////////////////////
// # GOLDEN RULE!!!! HONOR ABOVE ALL!!!!
////////////////////////////////////////
// NO NEW FILES!!!!!!!!!
////////////////////////////////////////

/**
 * ════════════════════════════════════════════════════════════════════════════════
 * FORGET PASSWORD POD - PASSWORD RESET ORCHESTRATOR (POD/PEA PATTERN)
 * ════════════════════════════════════════════════════════════════════════════════
 *
 * ARCHITECTURAL ROLE: Orchestrates password reset flow including email validation,
 * reset token generation request, and success confirmation display
 *
 * I[R{DVT}]O PATTERN:
 *   INPUT: Customer email address for password reset
 *   REQUIREMENTS: Email validation, API integration, security best practices
 *   OUTPUT: Password reset email sent, success confirmation displayed
 *
 * SECURITY: Intentionally doesn't reveal if email exists (prevents user enumeration attacks)
 * RATE LIMITING: Should implement rate limiting to prevent abuse (future enhancement)
 */

import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Pea_Lobby_ForgetPassword_SRC_Auth_Customer_Kings from '../pea/Bitsbound_Kings_Customer_Auth_SRC_ForgetPassword_Lobby_Pea.js';

const Pod_Lobby_ForgetPassword_SRC_Auth_Customer_Kings: React.FC = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [isLoading, setIsLoading] = useState(false);
  const [isSuccess, setIsSuccess] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const validateEmail = (email: string): boolean => {
    return /\S+@\S+\.\S+/.test(email);
  };

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    setError(null);

    if (!email) {
      setError('Email is required');
      return;
    }

    if (!validateEmail(email)) {
      setError('Please enter a valid email address');
      return;
    }

    setIsLoading(true);

    try {
      // TRANSFORMATION: Environment-aware auth backend URL
      // VALIDATION: Check for production hostnames (main domain OR direct Vercel app access)
      const hostname = window.location.hostname;
      const isProduction = hostname === 'www.bitsbound.com' ||
                          hostname === 'bitsbound.com' ||
                          hostname.includes('vercel.app');
      const authBackendUrl = isProduction
        ? 'https://bitsbound-auth-backend.vercel.app'  // DEFINITION: Production auth backend
        : 'http://localhost:2102';                      // DEFINITION: Local development (port 2102)
      const response = await fetch(`${authBackendUrl}/api/auth/forgot-password`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({ email })
      });
      
      const data = await response.json();
      
      if (response.ok && data.success) {
        setIsSuccess(true);
      } else {
        // Don't reveal if email exists or not for security
        setIsSuccess(true); // Show success even if email doesn't exist
      }
    } catch (error) {
      console.error('Password reset error:', error);
      setError('Unable to process request. Please try again.');
    } finally {
      setIsLoading(false);
    }
  };
  
  const handleEmailChange = (newEmail: string) => {
    setEmail(newEmail);
    if (error) {
      setError(null);
    }
  };
  
  const handleBackToSignIn = () => {
    navigate('/auth/sign-in');
  };
  
  return (
    <Pea_Lobby_ForgetPassword_SRC_Auth_Customer_Kings
      email={email}
      isLoading={isLoading}
      isSuccess={isSuccess}
      error={error}
      onEmailChange={handleEmailChange}
      onSubmit={handleSubmit}
      onBackToSignIn={handleBackToSignIn}
    />
  );
};

export default Pod_Lobby_ForgetPassword_SRC_Auth_Customer_Kings;